// Event Handlers
import { TRY_AGAIN } from './translations/error.handlers.translations';
// Types
import { ErrorBuilderHandlersType, ErrorMethodsHandlersType } from './types/error.handlers.type';

const setupErrorButtonConfigurationHandler = ({
  formatMessage,
  onTryAgainClick,
  setMainButtonConfiguration,
}: ErrorBuilderHandlersType): void => {
  setMainButtonConfiguration({
    children: formatMessage({ id: TRY_AGAIN }),
    onClick: onTryAgainClick,
  });
};

const ErrorHandlers = (props: ErrorBuilderHandlersType): ErrorMethodsHandlersType => ({
  handleSetupErrorLayoutButtonConfiguration: () => setupErrorButtonConfigurationHandler(props),
});

export { ErrorHandlers };
